// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oXhDV","left":"styles_left__2w4ey","right":"styles_right__1Byl5","alert":"styles_alert__2CsAV"};